<template><div><h1 id="quellenzusatz" tabindex="-1"><a class="header-anchor" href="#quellenzusatz"><span>Quellenzusatz</span></a></h1>
<p>Quellenzusatz — Definiert zusätzliche Attribute zu einer Quelle</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Wenn Quellen (typischerweise Adressbroker), zusätzliche Informationen zu den Adressen liefern, können diese in funtrade gespeichert und ausgewertet werden. Da jede Quelle ihre eigene Definition von Clusters, Gruppen etc. hat, gibt es hier die Möglichkeit, diese Zusatzinformationen zu benennen und zu beschreiben.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Quellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Qualifikator</dt>
<dd>Ein vordefinierter <a class="xref" href="ft.refdata.tblqquali.html" title="Qualifikator"><span class="refentrytitle">Qualifikator</span></a> als Zusatzinformation.</dd>
<dt>Beschreibung</dt>
<dd>Eine längere Beschreibung, was die Zusatzinformation bei dieser Quelle bedeutet.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblquelle.html" title="Quellen">Quelle</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.tblqquali.html" title="Qualifikator">Qualifikator</RouteLink></p>
</div></template>


